<template>
  <div>
    <template>
      <div>
        <div class="pt-3 l-m-b-20 align-items-center d-flex justify-content-between blocks">
          <div class="d-flex align-items-center">
            <h1 class="pr-3 w-full">Claim Types</h1>
            <div class="input-group search">
              <input class="form-control" type="text" v-model="q" @keyup="searchText($event)" placeholder="Search" />
              <button type="button" class="btn input-group-btn" @click="clearSearch">
                <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
              </button>
            </div>
          </div>
          <div class="text-right">
            <button class="btn btn-primary" @click="toggleSidebar">
              ADD CLAIM TYPE
            </button>
          </div>
        </div>
        <template v-if="!claimTypes">
          <vue-content-loading :width="800" :height="450">
            <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
          </vue-content-loading>
        </template>
        <template v-else>
          <div class="blocks">
            <SettingsClaimTypesBlock
              v-for="(type, index) in claimTypes"
              :key="index"
              :type.sync="type"
            />
          </div>
          <div class="row blocks">
            <div class="col-sm-6 mb-1 text-black-50 pl-0"
                 v-if="meta.total"
            >
              Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
            </div>
            <pagination class="col-sm-6 mb-1 pr-0" :change-page="changePage" :meta="meta" />
          </div>
        </template>
      </div>
    </template>

    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showCreateSidebar" @click.self="showCreateSidebar = false">
        <create-claim-type
          class="sidebar-right"
          @cancel="toggleSidebar()"
          @update="getAllClaimTypes"
        />
      </div>
    </transition>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import CreateClaimType from './SettingsCreateClaimType';
import SettingsClaimTypesBlock from './SettingsClaimTypesBlock';
import Pagination from '../../Pagination';

export default {
  components: {
    CreateClaimType,
    Pagination,
    SettingsClaimTypesBlock,
  },
  data: () => ({
    page: 1,
    q: '',
    sortKey: '',
    sortOrders: [],
    showCreateSidebar: false,
  }),
  computed: {
    ...mapState({
      claimTypes: state => state.claimTypes.paginatedClaimTypes.data,
      meta: state => state.claimTypes.paginatedClaimTypes.meta,
    }),
    ...mapGetters(['getClaimTypesSearched']),
  },
  created() {
    this.getPaginatedClaimTypes();
  },
  methods: {
    ...mapMutations(['setPaginatedClaimTypes']),
    ...mapActions(['getPaginatedClaimTypes', 'getClaimTypes']),
    changePage(pageNum) {
      this.page = pageNum;
      this.filter();
    },
    toggleSidebar() {
      this.showCreateSidebar = !this.showCreateSidebar;
    },
    searchText(e) {
      this.page = 1;
      if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
        const vm = this;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          vm.filter();
        }, 500);
      }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      this.getClaimTypesSearched(
        this.page,
        this.q,
        this.sortKey,
        this.sortOrders[this.sortKey] ? 'asc' : 'desc',
      );
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    sortBy(key) {
      this.sortKey = key;
      this.$set(this.sortOrders, key, !this.sortOrders[key]);
      this.filter();
    },
    getAllClaimTypes() {
      this.setPaginatedClaimTypes({});
      this.getPaginatedClaimTypes();
      this.getClaimTypes();
    },
  },
};
</script>
<style lang="scss" scoped>
.w-full {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/ClaimTypes/SettingsClaimTypesList.vue